import React, { useEffect, useState } from 'react'
import { Upload, Progress, Space, List, Image, Button, Form, Pagination } from "antd";
import { CloudDownloadOutlined, DiffOutlined, FundViewOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import MainLayouts from '../../../layouts/MainLayouts';
import _Api from '../../../services/Api/_Api';
import { _Button, _Date, _Input, _Label, _TitleBar } from '../../../services/Forms/Forms';
// import { _Row } from '../../services/Forms/LayoutBootstrap';

import moment from 'moment';
import { _Row } from '../../../services/Forms/LayoutBootstrap';
import { baseURL_R } from '../../../services/BaseUrl';
import { msg } from '../../../services/Toastr/Notify/_Toastr';
import { SocketIO, globalText } from '../../../services/Text/GlobalText';
import { ubahText } from '../../../services/Crypto';


function UploadBerkas(pr) {

    // const [defaultFileList, setDefaultFileList] = useState([]);
    const [progress, setProgress] = useState(0);
    const [loading, setloading] = useState(false);
    const [dataBerkas, setdataBerkas] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);


    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const uploadImage = async options => {
        let auth = sessionStorage.getItem(globalText.x_auth_access_token);

        const { onSuccess, onError, file, onProgress } = options;
        try {
            const F = new FormData();
            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                    'Authorization': auth && `Bearer ${ubahText(auth)}`

                },
                onUploadProgress: event => {
                    const percent = Math.floor((event.loaded / event.total) * 100);
                    setProgress(percent);
                    if (percent === 100) {
                        setTimeout(() => setProgress(0), 1000);
                    }
                    onProgress({ percent: (event.loaded / event.total) * 100 });
                }
            };
            F.append("konseling_id", pr.konseling_id);
            F.append("fileupload", file);
            // F.append("filename", file.uid);
            // F.append("deskripsi", file.name);
            // F.append("id_registerpengadaan", pr.id_reg);


            await axios.post(
                `${baseURL_R}/upload-bukti-transfer`, F, config
            ).then(res => {

                console.log(res)
                if (res.data.sts == "1") {
                    msg.success("Suksess");
                    SocketIO.emit("requestKonfirmasipembayaran", res.data)
                    pr.setudahUploadBuktiTf(true)
                } else {
                    msg.error(res.data.msg);
                    window.location.reload()
                }
            });

            // console.log(`options`, options)

            onSuccess("Ok");
        } catch (err) {
            // console.log("Eroor: ", err);
            const error = new Error("Some error");
            onError({ err });
        }
    };

    const handleOnChange = ({ file, fileList, event }) => {
        // console.log(file, fileList, event);
        //Using Hooks to update the state to the current filelist
        // setDefaultFileList(fileList);
        //filelist - [{uid: "-1",url:'Some url to image'}]
    };


    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>Upload Bukti Transfer</div>
            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </div>

    );

    return (
        <div className="">
            <br />
            <Upload
                // style={{height :"300px"}}
                accept="image/*"
                customRequest={uploadImage}
                // onChange={handleOnChange}
                onRemove={false}
                disabled={pr.dataOrder && pr.dataOrder.verifikasiby != null}
                showRemoveIcon={false}
                listType="picture-card"
                multiple
                onPreview={handlePreview}
                // onRemove={handleDrop}
                defaultFileList={pr.buktitf}
                className="image-upload-grid"
            >
                {pr.status != "MP9" && uploadButton}
                {/* <_Button label="Upload Berkas" icon={<DiffOutlined size="large" />} /> */}
            </Upload>
            {progress > 0 ? <Progress percent={progress} /> : null}

            <br />

            <br />
        </div>

    )
}

export default UploadBerkas
